<template>
  <v-container fluid>
    <v-data-table class="pt-3" flat :headers="Avenantheaders" :items="Contracts" :items-per-page="5"
      :loading="loading ? '#0482fb' : null" sort-by="">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Contrats en Alerte d'échéance</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <!-- {{ Contracts }} -->
                  <v-col cols="12" md="2">
                    <v-autocomplete outlined color="#0482fb" :items="userFile" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="fileName" dense flat background-color="grey lighten-4"
                      label="Nom / Raison Sociale ...">
                    </v-autocomplete>
                    <!-- <v-text-field outlined color="#0482fb" label="Nom / Raison Sociale ..." class="pt-5 pa-2"
                      v-model="fileName" prepend-inner-icon="mdi-magnify" dense flat
                      background-color="grey lighten-4"></v-text-field> -->
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro police ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="policeNumber" flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="companyNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="company" flat background-color="grey lighten-4" label="compangnie"></v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="product" flat background-color="grey lighten-4" label="Produit"></v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="monthRaprochement" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                      dense v-model="monthValue" flat background-color="grey lighten-4"
                      label="Mois d'échéance"></v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="yearArray" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="yearValue" flat background-color="grey lighten-4" label="Année d'échéance"></v-select>
                  </v-col>
                  <!-- <v-col cols="12" md="3">
              <v-select outlined 
                :items="natureprospect"
                class="pt-5 pa-2"
                 
                prepend-inner-icon="mdi-magnify"
                dense
                
                v-model="status"
                @change="onEnter"
                flat
                background-color="grey lighten-4"
                
                label="Status"
              ></v-select>
            </v-col> -->
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnter">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn class="white--text ma-2" color="warning" @click="editNotice(item)" icon>
          <v-icon size="30"> mdi-pencil-box-multiple-outline </v-icon>
        </v-btn>
      </template>
      <template v-slot:item.company="{ item }">
        <td>
          {{
            item.company && item.company.name ? item.company.name : item.company
          }}
        </td>
      </template>
      <template v-slot:item.dueDateMonth="{ item }">
        <td>
          <v-chip :color="getColor(item.dueDateMonth)" dark>
            {{ item.dueDateMonth }}
          </v-chip>
        </td>
      </template>
      <template v-slot:item.followUpRenewals="{ item }">
        <td>
          <v-chip :color="getColor(item.followUpRenewals.status)" dark>
            {{ item.followUpRenewals ? item.followUpRenewals.status : "" }}
          </v-chip>
        </td>
      </template>

      <template v-slot:item.followUpRenewalsObservation="{ item }">
        {{
          item.followUpRenewals && item.followUpRenewals.observation
            ? item.followUpRenewals.observation
            : ""
        }}
      </template>
      <template v-slot:item.file="{ item }">
        {{ item.file.name && item.file.name ? item.file.name : "" }}
      </template>
      <template v-slot:item.phone="{ item }">
        {{ item.file.phone }}
      </template>
      <template v-slot:item.email="{ item }">
        {{ item.file.email }}
      </template>
      <template v-slot:item.status="{ item }">
        {{
          item.followUpRenewals && item.followUpRenewals.status
            ? item.followUpRenewals.status
            : ""
        }}
      </template>
    </v-data-table>

    <!--  Pop up add file-->
    <v-dialog v-model="fileDialog" max-width="1000px">
      <v-card style="border-top:10px solid #0482fb">
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="4">
                <v-select outlined v-model="noticeModal.status" :items="natureprospect" label="Statut"></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field outlined color="#0482fb" v-model="noticeModal.sendAt" type="date"
                  label="Date envoi avis"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field outlined color="#0482fb" v-model="noticeModal.companyProjectRequestDate" type="date"
                  label="Date demande projet ( compagnie )"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field outlined color="#0482fb" v-model="noticeModal.customerProjectSendDate" type="date"
                  label="Date envoi projet ( client )"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field outlined color="#0482fb" v-model="noticeModal.companyContractRequestDate" type="date"
                  label="Date demande contrat  ( compagnie )"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field outlined color="#0482fb" v-model="noticeModal.customerContractSendDate" type="date"
                  label="Date envoi contrat ( client )"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field outlined color="#0482fb" v-model="noticeModal.paymentDate" label="Date de paiement"
                  type="date"></v-text-field>
              </v-col>
              <v-col cols="12" sm="8">
                <v-select outlined v-model="noticeModal.isPayed" :items="items" label="Contrat Payé"></v-select>
              </v-col>

              <v-col cols="12" sm="12">
                <v-textarea outlined v-model="noticeModal.observation" name="input-7-4"
                  label="Observation"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="white--text ma-2" color="error " text @click="closeNotice">
            Fermer
          </v-btn>
          <v-btn color="success" :loading="loading ? '#0482fb' : null" class="ml-5" @click="saveNotice">
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Etes vous sûrs de vouloire supprimer cet élément ?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="white--text ma-2" color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn class="white--text ma-2" color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Encaissement dialoge-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="contractDialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Encaissement contrat</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field outlined color="#0482fb" label="Commission"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field outlined color="#0482fb" label="Date de paiement" type="date"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="white--text ma-2" color="blue darken-1" text @click="contractDialog = false">
                Retour
              </v-btn>
              <v-btn class="white--text ma-2" color="blue darken-1" text @click="contractDialog = false">
                Encaisser
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
// import { addFile } from "@/api/admin";
import { manageNotice } from "@/api/user"; //
export default {
  name: "production",
  components: {},
  data: () => ({
    panel: [],
    switch1: true,
    tab: null,
    perssonel: [],
    garantietitre: [
      {
        tab: "RESPONSABILITE CIVILE CHEF D'ENTREPRISE",
        content: "Tab 1 Content",
      },
      { tab: "MULTIRISQUE PROFESSIONNELLE", content: "Tab 2 Content" },
      { tab: "GLOBAL DE BANQUE BOA", content: "Tab 3 Content" },
      { tab: "MULTIRISQUE HABITATION", content: "Tab 4 Content" },
      { tab: "TRC", content: "Tab 5 Content" },
      { tab: "IND", content: "Tab 6 Content" },
    ],
    items: ["Oui", "Non"],
    statutsItems: ["Oui", "Non"],
    natureprospect: [
      "Renouvelé",
      "En cours",
      "Non renouvelé",
      "Perdu",
      "Non Renouvelable",
    ],
    focus: "",
    noticeModal: {},
    events: [],
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    colors: ["red"],
    names: ["Appel"],
    colorss: ["green"],
    namess: ["Rendez vous"],
    categories: ["John Smith"],
    addgarantie: false,
    dialog: false,
    contractDialog: false,
    appels: false,
    newappel: false,
    companyNameList: [],
    productNameList: [],
    rdv: false,
    produit: false,
    cotation: false,
    garantie: false,
    contrat: false,
    notifications: false,
    sound: true,
    widgets: false,

    prospect: false,
    dialogDelete: false,
    categoriegarantie: [
      {
        titreCatégorie: "I- Responsabilité Civile Exploitation",
        value1: "",
        value2: "",
        Souscategoriegarantie: [
          {
            titreCatégorie: "domage",
            value1: "",
            value2: "",
          },
          {
            titreCatégorie: "domage",
            value1: "",
            value2: "",
          },
        ],
      },
      {
        titreCatégorie: "II- Responsabilité Civile Professionnelle",
        value1: "",
        value2: "",
        Souscategoriegarantie: [
          {
            titreCatégorie: "Domage1",
            value1: "",
            value2: "",
          },
        ],
      },
      {
        titreCatégorie: "III- Défense et Recours",
        value1: "10 000 000",
        value2: "Néant",
      },
    ],
    produitsugest: [
      {
        text: " Liste des produits",
        value: "name",
      },
    ],
    monthRaprochement: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    yearArray: [],
    Avenantheaders: [
      {
        text: "Actions",
        width: "100px",
        align: "left",
        value: "actions",
        sortable: false,
      },
      // {
      //   text: "Numéro dossier",
      //   align: "start",
      //   sortable: false,
      //   value: "policeNumber",
      // },
      { text: "Mois d'échéance", width: "200px", value: "dueDateMonth" },
      { text: "Status", width: "200px", value: "followUpRenewals.status" },
      { text: "Nom / Raison Sociale", width: "200px", value: "file" },
      { text: "Contact", width: "200px", value: "phone" },
      { text: "Mail", width: "200px", value: "email" },
      { text: "Prime nette", width: "200px", value: "netPrime" },
      { text: "Prime ttc", width: "200px", value: "totalPrime" },

      { text: "Branche", width: "200px", value: "product" },
      { text: "Compagnie", width: "200px", value: "company" },
      { text: "Numéro Police", width: "200px", value: "policeNumber" },
      { text: "Effet", width: "200px", value: "effectDateFr" },
      { text: "Echéance", width: "200px", value: "dueDateFr" },
      {
        text: "Observation",
        width: "200px",
        value: "followUpRenewalsObservation",
      },
    ],
    produittake: [
      {
        text: "Liste des produits Proposer",
        value: "nom",
      },
    ],
    headers: [
      {
        text: "Nom / Raison Sociale",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Nature", value: "nature" },
      // { text: "Description", value: "description" },
      { text: "Domaine d'activité", value: "activityField" },
      { text: "Mail", value: "email" },
      { text: "Téléphone", value: "phone" },
      { text: "Date d'aniversaire", value: "birthday" },
      { text: "Localité", value: "location" },
    ],
    listproduit: [
      {
        name: "Cart d'identité",
      },
      {
        name: "permis de conduit",
      },
      {
        name: "Atestation de residence",
      },
    ],
    prospectdata: [],
    editedIndex: -1,
    fileModal: {
      name: "",
      nature: "",
      phone: "",
      activity: "",
      email: "",
      birthday: "",
      location: "",
      prospects: [],
    },
    defaultItem: {
      nom: "",
      Nature: "",
      Contact: "",
      Activité: "",
      Mail: "",
      Anniverssaire: "",
      Localisation: "",
    },
    email: "",
    name: "",
    contact: "",
    birthday: "",
    emailRules: [
      (v) => !!v || "E-mail is ",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    loader: false,
    loading: false,
    fileDialog: false,
  }),

  mounted() {
    this.initContracts();
  },
  computed: {
    ...mapGetters(["Contracts", "Companies", "Products", "Files"]),
    formTitle() {
      return this.editedIndex === -1
        ? "suivi des renouvellements"
        : "suivi des renouvellements ";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    Contracts() { },
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      // this.seedCoinsuranceCompanyNameList();
    },
    Products() {
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
    Files() {
      this.userFile = defaultMethods.getNameList(this.Files.docs);
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions([
      "getContracts",
      "postSearchEcheance",
      "getProducts",
      "getCompanies",
      "getFiles"
    ]),
    async makeSearchContract() {
      this.loading = true;
      try {
        await this.postSearchEcheance({
          fileName: defaultMethods.getItemId(this.Files.docs, this.fileName),
          product: this.product,
          policeNumber: this.policeNumber,
          actionType: this.actionType,
          company: this.company,
          withDeadlineNotice: true,
          startDueMonth: this.monthValue,
          dueYear: this.yearValue,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },
    onEnter: function () {
      this.makeSearchContract();
    },
    async YEARS() {
      // const years = []
      const d = new Date();
      let year = d.getFullYear();
      year = year - 10
      // alert(JSON.stringify(year - 10))
      for (let index = 0; index < 20; index++) {
        const element = year + index;
        // alert(element)
        this.yearArray.push(element)
      }
      // alert(JSON.stringify(this.yearArray))
    },

    initialize() {
      this.prospectdata = [
        {
          nom: "Koudenou Jean Baptiste",
          Nature: "Physique",
          Contact: "62144455 / 22335747",
          Activité: "Député",
          Mail: "Jean95@test.com",
          Localisation: "CNSAD",
          Anniverssaire: "22/08/2000",
        },
        {
          nom: "Koudenou Jean Baptiste",
          Nature: "Physique",
          Contact: "62144455 / 22335747",
          Activité: "Député",
          Mail: "Jean95@test.com",
          Localisation: "CNSAD",
          Anniverssaire: "22/08/2000",
        },
      ];
    },
    closeForm() {
      this.fileModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = false;
      this.dialogDelete = false;

      this.editedIndex = -1;
    },
    // files
    async initContracts() {
      this.loading = true;
      try {
        // alert('ok')
        await this.YEARS()
        await this.getContracts({ withDeadlineNotice: true });
        await this.getCompanies();
        await this.getFiles({ withoutPeriod: true });
        await this.getProducts({ name: this.searchData });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
    getColor(item) {
      if (item == "Janvier") return "#2a9d8f";
      else if (item == "Février") return "#e9c46a";
      else if (item == "Mars") return "#a8dadc";
      else if (item == "Avril") return "#e36414";
      else if (item == "Mai") return "#c8b6ff";
      else if (item == "Juin") return "#3a0ca3";
      else if (item == "Juillet") return "#edf6f9";
      else if (item == "Août") return "#80ed99";
      else if (item == "Septembre") return "#004e89";
      else if (item == "Octobre") return "#ff9770";
      else if (item == "Novembre") return "#720026";
      else if (item == "Décembre") return "#3da5d9";
      else return "green";
    },
    async saveNotice() {
      this.loading = true;
      try {
        // update
        await manageNotice({
          schema: {
            status: this.noticeModal.status,
            sendAt: this.noticeModal.sendAt,
            companyProjectRequestDate: this.noticeModal
              .companyProjectRequestDate,
            customerProjectSendDate: this.noticeModal.customerProjectSendDate,
            companyContractRequestDate: this.noticeModal
              .companyContractRequestDate,
            customerContractSendDate: this.noticeModal.customerContractSendDate,
            paymentDate: this.noticeModal.paymentDate,
            isPayed: this.noticeModal.isPayed,
            observation: this.noticeModal.observation,
          },
          id: this.noticeModal.contract,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Notice")
        );

        this.initContracts();
        this.closeNotice();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeNotice() {
      this.fileDialog = false;
      this.noticeModal = {};
    },
    editNotice(item) {
      this.noticeModal = {};
      if (item.followUpRenewals) {
        this.noticeModal = item.followUpRenewals;
      }

      this.noticeModal.contract = item._id;
      //alert(JSON.stringify(this.noticeModal));
      this.fileDialog = true;
    },
    all() {
      this.panel = [...Array(this.items.length).keys()].map((k, i) => i);
    },
    addPersonnel() {
      this.fileModal.prospects.push({
        fullName: this.name,
        email: this.email,
        contact: this.contact,
        birthday: this.birthday,
      });

      this.initPersonnelForm();
    },
    initPersonnelForm() {
      this.name = "";
      this.email = "";
      this.contact = "";
      this.birthday = "";
    },
    // Reset the panel
    none() {
      this.panel = [];
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    addProspect() {
      this.editedIndex = -1;
      this.fileModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = true;
    },
    updateProspect(item) {
      this.editedIndex = 1;
      this.fileModal = Object.assign({}, item);
      this.fileDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.fileModal = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.prospectdata.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.prospectdata[this.editedIndex], this.fileModal);
      } else {
        this.prospectdata.push(this.fileModal);
      }
      this.close();
    },
  },
};
</script>

<style scoped>

</style>
